import { render, staticRenderFns } from "./testsOfChoice.vue?vue&type=template&id=14139bb4&scoped=true&"
import script from "./testsOfChoice.vue?vue&type=script&lang=js&"
export * from "./testsOfChoice.vue?vue&type=script&lang=js&"
import style0 from "./testsOfChoice.vue?vue&type=style&index=0&id=14139bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14139bb4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/index/testsOfChoice.vue
// module id = null
// module chunks = 